import React from 'react';
import styled from 'styled-components';


const Wrapper = styled.div.withConfig({displayName:'-Wrapper'})`
	position: relative;
	background-color: #0d609d;
	color: #ffffff;
	padding: 8px;
	text-align: center;
	flex-grow: 0;
	flex-shrink: 0;
`;
const Back = styled.div.withConfig({displayName:'-Back'})`
	position: absolute;
	top: 6px;
	left: 14px;
	font-size: 20px;
	font-weight: 500;
	cursor: pointer;
	width: 26px;
	height: 26px;
`;
const Download = styled.div.withConfig({displayName:'-Download'})`
	position: absolute;
	top: 6px;
	right: 14px;
	font-size: 20px;
	font-weight: 500;
	cursor: pointer;
	width: 26px;
	height: 26px;
`;
const Title = styled.div.withConfig({displayName:'-Title'})`
	font-size: 17px;
	font-weight: 500;
`;


const Topbar = ({onBack, downloadData, children}) => {
  return (
    <Wrapper>
			{onBack ? 
				<Back onClick={() => onBack()}>
					<i className="fas fa-chevron-left"></i>
				</Back>
			: null }
			<Title>{children}</Title>	
			{downloadData ? 
				<Download onClick={downloadData}>
					<i className="fas fa-file-excel"></i>
				</Download>
			: null }	
		</Wrapper>
  )
}

export default Topbar;
